@if (lockerCart.length > 0 && !orderDone && menu) {
  <div class="new-order">
      <h2>{{ 'locker.cart.new_order' | translate }}</h2>
      <p>{{ 'locker.cart.new_order_info' | translate }}</p>
      <div class="spirits">
        @for (lockerSpirit of lockerCart; track lockerSpirit.spirit.uuid) {
          @if (lockerSpirit.quantity > 0) {
            <div class="spirit">
                <div class="spirit-header">
                    {{ lockerSpirit.spirit.catalogSpirit.name }}
                </div>
                <div class="spirit-body">
                    <div class="spirit-body-image">
                        <img src="{{ lockerSpirit.spirit.catalogSpirit.image | spiritImage }}"/>
                    </div>
                    <div class="spirit-body-info">
                        <div class="spirit-body-info-header">
                          <small>{{ lockerSpirit.spirit | spiritTranslation:'subname' }}</small>
                          <small>
                              <em>
                                  @if (lockerSpirit.spirit.catalogSpirit.type) {
                                      {{ lockerSpirit.spirit.catalogSpirit.type | catalogTranslation }}
                                  }
                                  @if (lockerSpirit.spirit.catalogSpirit.type && lockerSpirit.spirit.catalogSpirit.region) {
                                      -
                                  }
                                  @if (lockerSpirit.spirit.catalogSpirit.region) {
                                      {{ lockerSpirit.spirit.catalogSpirit.region | catalogTranslation }}
                                  }
                              </em>
                          </small>
                        </div>
                        <ul>
                            @if (lockerSpirit.price) {
                              <li>{{ 'locker.cart.item_price' | translate }}: <b>{{ lockerSpirit.price }} {{ menu.currency?.symbol }}</b></li>
                            }
                            <li>{{ 'locker.cart.quantity' | translate }}: <b>{{ lockerSpirit.quantity }}</b></li>
                            @if (lockerSpirit.price) {
                              <li><b class="uppercase">{{ 'locker.cart.total' | translate }}: {{ toFixed(lockerSpirit.price * lockerSpirit.quantity) }} {{ menu.currency?.symbol }}</b></li>
                            } @else {
                              <li><b>{{ 'locker.cart.ask_price' | translate }}</b></li>
                            }
                        </ul>
                        <div class="spirit-body-info-actions">
                            <div class="spirit-body-info-actions-qty">
                                <button mat-flat-button color="primary" (click)="substractQty(lockerSpirit);" [disabled]="lockerSpirit.quantity < 2">
                                    <mat-icon>remove</mat-icon>
                                </button>
                                <input type="number" min="0" [(ngModel)]="lockerSpirit.quantity" (input)="updateCart()"/>
                                <button mat-flat-button color="primary" (click)="addQty(lockerSpirit)">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                            <button mat-flat-button color="warn" (click)="lockerSpirit.quantity = 0; lockerSpirit.maxQty = 0; lockerSpirit.spirit.stock = 0; updateCart();"><mat-icon>delete</mat-icon></button>
                        </div>
                    </div>
                </div>
            </div>
          }
        }
      </div>
      <div class="footer">
        <div>
          <h1 class="uppercase white">
            @if (total > 0) {
              {{ 'locker.cart.total' | translate }}:
              {{ toFixed(total) }}{{ menu.currency?.symbol }}
            }
          </h1>
          @if (total > 0 && spiritWithoutPrice) {
            <h5 class="text-warning">{{ 'locker.cart.spirits_without_price' | translate }}</h5>
          }
        </div>
          <button mat-flat-button color="accent" (click)="confirmOrder()">{{ 'locker.cart.confirm_order' | translate }}</button>
      </div>
  </div>
}

@if (orderDone) {
  <div class="new-order order-done">
    <h2>{{ 'locker.cart.new_order' | translate }}</h2>
    <p>{{ 'locker.cart.new_order_done' | translate }}</p>
    <mat-icon>check</mat-icon>
  </div>
}